var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"licenses"},[_c('b-card',[_c('LicensesForm',{attrs:{"plans":_vm.plans,"companyLicenses":_vm.companyLicenses},on:{"chosen":_vm.chosenPlan}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }